__turbopack_context__.v({
  "tabletContent": "ojT-OW_tabletContent",
  "webContent": "ojT-OW_webContent",
});
